import React from 'react'
import type { TFunction } from 'i18next'
import type { ElectricityGridOperator } from '@popety-io/types'
import {
  ComparisonCard,
  ComparisonCardTitle,
  GridOperatorTable,
  GridOperatorTableHeader,
  GridOperatorTableRow,
  GridOperatorTableCell,
} from '../ElectricitySection.styles'

export interface GridOperatorComparisonCardProps {
  gridOperators: ElectricityGridOperator[]
  t: TFunction
}

export const GridOperatorComparisonCard: React.FC<
  GridOperatorComparisonCardProps
> = ({ gridOperators, t }) => {
  // Only show operators with current prices (exclude historical operators)
  const activeOperators = gridOperators.filter((op) => op.prices != null)

  if (!activeOperators || activeOperators.length === 0) return null

  // Sort grid operators by total price (cheapest first)
  const sortedOperators = [...activeOperators].sort(
    (a, b) => a.prices!.price_total - b.prices!.price_total
  )

  return (
    <ComparisonCard>
      <ComparisonCardTitle>{t('gridOperators.title')}</ComparisonCardTitle>

      <div style={{ overflowX: 'auto' }}>
        <GridOperatorTable>
          <thead>
            <tr>
              <GridOperatorTableHeader>
                {t('gridOperators.name')}
              </GridOperatorTableHeader>
              <GridOperatorTableHeader>
                {t('gridOperators.total')}
              </GridOperatorTableHeader>
              <GridOperatorTableHeader>
                {t('gridOperators.distribution')}
              </GridOperatorTableHeader>
              <GridOperatorTableHeader>
                {t('gridOperators.energy')}
              </GridOperatorTableHeader>
              <GridOperatorTableHeader>
                {t('gridOperators.taxes')}
              </GridOperatorTableHeader>
              <GridOperatorTableHeader>
                {t('gridOperators.supplement')}
              </GridOperatorTableHeader>
            </tr>
          </thead>
          <tbody>
            {sortedOperators.map((operator) => (
              <GridOperatorTableRow key={operator.grid_operator_number}>
                <GridOperatorTableCell>
                  {operator.grid_operator_name}
                </GridOperatorTableCell>
                <GridOperatorTableCell>
                  <strong>{operator.prices!.price_total.toFixed(2)}</strong>
                </GridOperatorTableCell>
                <GridOperatorTableCell>
                  {operator.prices!.price_distribution.toFixed(2)}
                </GridOperatorTableCell>
                <GridOperatorTableCell>
                  {operator.prices!.price_energy.toFixed(2)}
                </GridOperatorTableCell>
                <GridOperatorTableCell>
                  {operator.prices!.price_taxes.toFixed(2)}
                </GridOperatorTableCell>
                <GridOperatorTableCell>
                  {operator.prices!.price_supplement.toFixed(2)}
                </GridOperatorTableCell>
              </GridOperatorTableRow>
            ))}
          </tbody>
        </GridOperatorTable>
      </div>
    </ComparisonCard>
  )
}
